import { NotificationType } from '@shared/enums/notification.enum';

export const isEmailNotificationType = (type: NotificationType) =>
  type === NotificationType.EMAIL;
